import * as actionsTypes from './constants';
import * as actionsInterfaces from './types';
import { IAction } from '../types';

export const signUpRequest = (
	name: string,
	email: string,
	password: string,
	callback?: (result: any, error: any) => void,
): actionsInterfaces.ISignUpRequestAction => {
	return {
		type: actionsTypes.SIGNUP_REQUEST,
		name,
		email,
		password,
		callback,
	};
};

export const loginRequest = (
	email: string,
	password: string,
	callback?: (result: any, error: any) => void,
): actionsInterfaces.ILoginRequestAction => {
	return {
		type: actionsTypes.LOGIN_REQUEST,
		email,
		password,
		callback,
	};
};

export const login = (
	authUser: actionsInterfaces.IAuthUser,
): actionsInterfaces.ILoginAction => {
	return {
		type: actionsTypes.LOGIN,
		authUser,
	};
};

export const logoutRequest = (
	authUser: actionsInterfaces.IAuthUser,
): actionsInterfaces.ILoginAction => {
	return {
		type: actionsTypes.LOGOUT_REQUEST,
		authUser,
	};
};

export const logout = (): IAction => {
	return {
		type: actionsTypes.LOGOUT,
	};
};

export const logoutImmediate = (): IAction => {
	// This action can be used to logout immediately without API call
	return {
		type: actionsTypes.LOGOUT,
	};
};

export const rehydrateAuth = (): IAction => {
	return {
		type: actionsTypes.REHYDRATE_AUTH,
	};
};

export const rehydrateComplete = (): IAction => {
	return {
		type: actionsTypes.REHYDRATE_COMPLETE,
	};
};

